import React from "react";
import { Card, CardBody, FormGroup } from "reactstrap";
import CustomAutoSuggest from "../../../CommonElements/CustomAutoSuggest";

const cityTransferComp = ({
  getAddressData,
  handleSourceSelectChange,
  handleDestSelectChange,
  register,
  setValue,
  watch
}) => {
  return (
    <Card className="address-box">
      <CardBody className="address-body">
        <div className="location-timeline  c-to-c">
          <div className="location-media">
            <div className="circle-dot source"></div>
            <div className="city-details">
              <div className="city-content">
                <FormGroup className="col-12">
                  <CustomAutoSuggest
                    id={"Source"}
                    handleSelectChange={handleSourceSelectChange}
                    options={getAddressData}
                    placeholder="Source"
                    registerName={"sourceAddress"}
                    register={register}
                    isClearable={true}
                    setValue={setValue}
                    watch={watch}
                    dependentRegisterName={"sourceAddressDropdown"}
                  />
                </FormGroup>
              </div>
            </div>
          </div>
          <div className="location-media">
            <div className="circle-dot"></div>
            <div className="city-details">
              <div className="city-content">
                <FormGroup className="col-12">
                  <CustomAutoSuggest
                    id={"Destination"}
                    handleSelectChange={handleDestSelectChange}
                    options={getAddressData}
                    placeholder="Destination"
                    register={register}
                    registerName={"destAddress"}
                    isClearable={true}
                    setValue={setValue}
                    watch={watch}
                    dependentRegisterName={"destAddressDropdown"}
                  />
                </FormGroup>
              </div>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default cityTransferComp;
